const LIST_FILTER = "list";
const NUMBER_FILTER = "number";
const BOOLEAN_FILTER = "boolean";

const RANGE = "4";

function getFilterData(field, query) {
    const id = `${field}_global`;
    const filterValue = query[id];
    const filterType = query[`${id}_filterType`];
    const searchType = query[`${id}_searchType`];

    return { id, filterValue, filterType, searchType };
}

function getListFilterValue(value = "") {
    return value.split(",").map((item) => ({ id: item }));
}

function getRangeFilterValue(value = "") {
    const [start, end] = value.split(",");
    return { start, end };
}

function getFilterFromQuery(field, query) {
    const { id, filterValue, filterType, searchType } = getFilterData(field, query);

    if (filterValue === undefined) return null;

    if (filterType === LIST_FILTER) {
        const value = getListFilterValue(filterValue);

        return {
            id,
            type: filterType,
            searchType,
            value,
        };
    }

    if (filterType === NUMBER_FILTER && searchType === RANGE) {
        const value = getRangeFilterValue(filterValue);

        return {
            id,
            type: filterType,
            searchType,
            value,
        };
    }

    if (filterType === BOOLEAN_FILTER) {
        return {
            id,
            type: filterType,
            value: filterValue,
        };
    }

    return {
        id,
        type: filterType,
        searchType,
        value: filterValue,
    };
}

export function getFiltersFromQuery(fields, query = {}) {
    const filters = [];

    fields.forEach((field) => {
        const { code } = field;

        const filter = getFilterFromQuery(code, query);

        if (filter) {
            filters.push(filter);
        }
    });

    return filters;
}

function transformFilterToQuery(filter) {
    const { id, type, searchType, value } = filter;

    let filterValue = null;
    let withSearchType = true;

    if (type === LIST_FILTER) {
        if (value.length) {
            filterValue = value.map((i) => i.id).join(",");
        }
    } else if (type === NUMBER_FILTER && searchType === RANGE) {
        if (value) {
            const { start = 0, end = 0 } = value;
            filterValue = `${start},${end}`;
        }
    } else if (type === BOOLEAN_FILTER) {
        filterValue = value;
        withSearchType = false;
    } else {
        filterValue = value;
    }

    const query = {};

    if (!filterValue) return query;

    query[id] = filterValue;
    query[`${id}_filterType`] = type;

    if (withSearchType) {
        query[`${id}_searchType`] = searchType;
    }

    return query;
}

export function transformFiltersToQuery(filters) {
    let query = {};

    filters.forEach((filter) => {
        const queryParams = transformFilterToQuery(filter);
        query = {
            ...query,
            ...queryParams,
        };
    });

    return query;
}
